import React, { useState } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import MasterTabs from "../Master/MasterTabs";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const { user, loading } = useAuth();
  const navigate = useNavigate();
  const [values, setValues] = useState({
    oldPassword: "",
    newPassword: "",
    confirmPassword: "",
  });
  const [errors, setErrors] = useState({});
  const [btnLoading, setBtnLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    oldPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const validate = () => {
    let temp = {};
    temp.oldPassword = values.oldPassword !== "";
    temp.newPassword = values.newPassword !== "";
    temp.confirmPassword =
      values.confirmPassword !== "" &&
      values.newPassword === values.confirmPassword;

    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const resetForm = () => {
    setValues({
      oldPassword: "",
      newPassword: "",
      confirmPassword: "",
    });
    setErrors({});
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (validate()) {
      setBtnLoading(true);

      try {
        const payload = {
          UserId: user.id,
          OldPassword: values.oldPassword,
          NewPassword: values.newPassword,
        };

        const res = await apiService.post(config.CHANGEPASSWORD, payload);

        if (res === true) {
          resetForm();
          toast.success("Password changed successfully!");
        } else if (res === false) {
          toast.error("Current password is incorrect");
        } else {
          toast.error("Failed to change password. Please try again.");
        }
      } catch (error) {
      } finally {
        setBtnLoading(false);
      }
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };

  const togglePasswordVisibility = (field) => {
    setShowPassword((prev) => ({
      ...prev,
      [field]: !prev[field],
    }));
  };

  if (loading) return <p>Loading...</p>;

  if (!user) {
    navigate("/");
  }

  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="col-xl-12">
              <div className="card">
                <div className="p-2">
                  <MasterTabs pageName="CHANGEPASSWORD" />
                </div>
                <div className="card-body">
                  <div className="row justify-content-center">
                    <div className="col-md-6">
                      <div className="card">
                        <div className="card-header bg-primary">
                          <h5 className="card-title mb-0 text-white">
                            Change Your Password
                          </h5>
                        </div>
                        <div className="card-body">
                          <form onSubmit={handleSubmit}>
                            <div className="mb-3">
                              <label className="form-label">
                                Current Password
                              </label>
                              <div className="position-relative">
                                <input
                                  type={
                                    showPassword.oldPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className={
                                    "form-control" +
                                    applyErrorClass("oldPassword")
                                  }
                                  name="oldPassword"
                                  value={values.oldPassword}
                                  onChange={handleInputChange}
                                  placeholder="Enter your current password"
                                  maxLength={45}
                                />
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    togglePasswordVisibility("oldPassword")
                                  }
                                >
                                  {showPassword.oldPassword ? (
                                    <i className="ri-eye-line"></i>
                                  ) : (
                                    <i className="ri-eye-off-line"></i>
                                  )}
                                </span>
                                {errors.oldPassword === false && (
                                  <div className="validationerror">
                                    Please enter current password
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="mb-3">
                              <label className="form-label">New Password</label>
                              <div className="position-relative">
                                <input
                                  type={
                                    showPassword.newPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className={
                                    "form-control" +
                                    applyErrorClass("newPassword")
                                  }
                                  name="newPassword"
                                  value={values.newPassword}
                                  onChange={handleInputChange}
                                  placeholder="Enter your new password (min. 6 characters)"
                                  maxLength={45}
                                />
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    togglePasswordVisibility("newPassword")
                                  }
                                >
                                  {showPassword.newPassword ? (
                                    <i className="ri-eye-line"></i>
                                  ) : (
                                    <i className="ri-eye-off-line"></i>
                                  )}
                                </span>
                                {errors.newPassword === false && (
                                  <div className="validationerror">
                                    Please enter new password
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="mb-3">
                              <label className="form-label">
                                Confirm New Password
                              </label>
                              <div className="position-relative">
                                <input
                                  type={
                                    showPassword.confirmPassword
                                      ? "text"
                                      : "password"
                                  }
                                  className={
                                    "form-control" +
                                    applyErrorClass("confirmPassword")
                                  }
                                  name="confirmPassword"
                                  value={values.confirmPassword}
                                  onChange={handleInputChange}
                                  placeholder="Confirm your new password"
                                  maxLength={45}
                                />
                                <span
                                  className="position-absolute"
                                  style={{
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    togglePasswordVisibility("confirmPassword")
                                  }
                                >
                                  {showPassword.confirmPassword ? (
                                    <i className="ri-eye-line"></i>
                                  ) : (
                                    <i className="ri-eye-off-line"></i>
                                  )}
                                </span>
                                {errors.confirmPassword === false && (
                                  <div className="validationerror">
                                    {values.confirmPassword === ""
                                      ? "Please enter confirm password"
                                      : "Passwords don't match"}
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="mt-4">
                              <button
                                type="submit"
                                className="btn btn-primary w-100"
                                disabled={btnLoading}
                              >
                                {btnLoading ? (
                                  <>
                                    <span
                                      className="spinner-border spinner-border-sm me-2"
                                      role="status"
                                      aria-hidden="true"
                                    ></span>
                                    Processing...
                                  </>
                                ) : (
                                  "Change Password"
                                )}
                              </button>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePassword;
